import * as types from "../../constants/constants";

export const RakutenList = () => ({
  type: types.RAKUTEN_LIST,
});

export const RakutenListSuccess = (payload) => {
  return {
    type: types.RAKUTEN_LIST_SUCCESS,
    payload
  }
  
};

export const RakutenListFailure = (error) => ({
  type: types.RAKUTEN_LIST_FAILURE,
  payload: error,
});

